import { CallLog } from '../../../../../call/call-log/call-log';

import { INBOUND_CALL_SESSION_COLLECTION_NAME } from './inbound-call-session-collection-name';

export const getInboundCallSessionCollection = (orgId: string, inboundCallSessionIdId: string) =>
  `${CallLog.getSchema().getCollection(orgId)}/${inboundCallSessionIdId}/${INBOUND_CALL_SESSION_COLLECTION_NAME}`;
